<script lang="js">
    export let search = {};
    let options = search.module.options;
    let enablePagination = options.pagination.children.enable.value;
    let keyword, prevKeyword;
    let page, totalPages;
    let timer;
    let data = [];
    let loading;

    /** Show Search Results */
    async function showSearchResults(response){
        totalPages = response.headers.get('X-WP-TotalPages');
        if(response.status===200 && keyword){
            let result = await response.text();
                result = JSON.parse(result).filter((r) => r.subtype !== 'fab');
            data = [ ...data, ...result ];
        } else { data = []; }
        loading = false;
        prevKeyword = keyword;
    }

    /** Ajax Search */
    const ajaxSearch = () => {
        /** Ajax Params */
        let url = `${ window.FAB_PLUGIN.rest_url }wp/v2/search`;
        let params = {
            search: keyword,
            per_page: options.pagination.children.per_page.value,
            page,
        };

        /** Ajax Search */
        url += `?` + Object.keys(params).map((k, i) => `${k}=${params[k]}`).join('&');
        fetch(url).then(response => showSearchResults(response));
    }

    /** Handle on KeySearch */
    const handleKeySearch = (e) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            /** Ignore Same Keyword */
            if(keyword==prevKeyword) return;

            /** Control Component */
            loading = true;
            data = [];
            page = 1;

            ajaxSearch();
        }, 500);
    }
</script>

<div class="flex flex-wrap item-center relative">
    <form method="GET" action="/" class="w-full p-4">
        {#if loading}
            <img src="{`${JSON.parse(window.FAB_PLUGIN.path).plugin_url}assets/img/loading.gif`}"
                class="w-10 h-10 absolute right-4" alt="Loading..." style="z-index:10;" />
        {/if}
        <div class="relative">
            <input type="search"
                   id="fab-search"
                   name="s"
                   class="w-full text-xl font-medium focus:outline-none"
                   placeholder="{ options.label.value }"
                   autocomplete="off"
                   bind:value={keyword}
                   on:keydown={handleKeySearch}
            >
        </div>
    </form>
    {#if data && data.length }
        <div id="fab-search-results" class="w-full border-t border-gray-200">
                {#each data as post, i}
                    <div class="w-full flex justify-between p-4 border-gray-200 hover:bg-gray-50"
                        class:border-b={ i<data.length-1 }>
                        <a href="{post.url}"><span class="my-auto">{@html post.title}</span></a>
                        <div class="my-auto pl-2">
                            <a href="{post.url}" target="_blank"><em class="fas fa-external-link-alt text-gray-400"></em></a>
                        </div>
                    </div>
                {/each}
            {#if page<totalPages && enablePagination }
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <div class="w-full flex justify-between p-4 cursor-pointer border-t border-gray-200 hover:bg-gray-100"
                     on:click={() => { page = page + 1; ajaxSearch(); }}
                     >
                    Load More...
                </div>
            {/if}
        </div>
    {:else if keyword && !loading}
        <div class="w-full flex justify-between p-4 border-t border-gray-200 cursor-pointer hover:bg-gray-100 text-red-400">
            Search Not Found!
        </div>
    {/if}
</div>
<style lang="scss">
    #fab-search-results {
        max-height:500px;
        overflow: auto;
    }
</style>